import {Schema, FieldSet, FieldComponent, Component} from 'simpli-web-sdk'
import {ResponsavelCollection} from '@/model/collection/ResponsavelCollection'
import SearchResponsavel from '@/components/SearchResponsavel.vue'
import {RelatorioAutomatico} from '@/model/resource/RelatorioAutomatico'

export class InputRelatorioAutomaticoSchema extends Schema {
  collectionResponsavel = new ResponsavelCollection().noPagination()

  readonly name = 'InputRelatorioAutomatico'

  formFields = ['pastaFTP', 'senhaFTP', 'periodoInicial', 'ativo']

  readonly fieldSet: FieldSet<RelatorioAutomatico> = {
    responsavel: (schema): FieldComponent => ({
      is: SearchResponsavel,
      bind: {
        label: this.translateFrom(schema.fieldName),
        class: 'col-span-2',
        collection: this.collectionResponsavel,
        noResultLabel: this.translateFrom('noResultLabel'),
        noOptionsLabel: this.translateFrom('noOptionsLabel'),
        required: true,
      },
    }),
    pastaFTP: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxLength: 255,
        label: this.translateFrom(schema.fieldName),
        required: true,
      },
    }),
    senhaFTP: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'password',
        maxLength: 50,
        label: this.translateFrom(schema.fieldName),
        required: true,
      },
    }),
    periodoInicial: (schema): FieldComponent => ({
      is: Component.InputDate,
      bind: {
        label: this.translateFrom(schema.fieldName),
        required: true,
      },
    }),
    ativo: (schema): FieldComponent => ({
      is: Component.InputCheckbox,
      bind: {
        label: this.translateFrom(schema.fieldName),
        class: 'pretty p-switch p-fill justify-center mt-8',
        labelClass: 'relative state',
      },
    }),
  }
}
